// "use client";
import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { CreateProjectDto, CreateProjectResponse } from '../../lib'
import { methods } from '@/shared/api/constants'
import { getSession } from 'next-auth/react'
import { UpdateProjectParams } from '@/shared/api/end-points/project'

const updateproject = async ({ projectId, ...dto }: CreateProjectDto & UpdateProjectParams) => {
  const session = await getSession()
  let userId = session?.user?.data.id || 0
  const payload = { ...dto, user_id: userId }

  const res = await api.json<Partial<CreateProjectResponse>>(API_END_POINTS.project.updateProject({ projectId }), {
    method: methods.post,
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return res
}

export default updateproject
